module.exports = __webpack_public_path__ + "img/filter-lines.3a4dfce3.svg";